// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call_websocket.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import { file_call_call_model } from './call/call_model_pb';
import type { RealtimeCallEvent } from './call/call_realtime_events_pb';
import { file_call_call_realtime_events } from './call/call_realtime_events_pb';
import type {
  AddMembersToCallRequest,
  CallPingRequest,
  ClearPermissionsForMemberRequest,
  CreatePermissionRequestRequest,
  DeclineCallRequest,
  FinishForAllRequest,
  ForceMuteRequest,
  GetCallLinkRequest,
  GetCallMembersByCameraOrScreenIdsRequest,
  GetCallMembersByIdsRequest,
  GetCallMembersRequest,
  GetCallPermissionsRequest,
  GetPermissionRequestsRequest,
  JoinToCallRequest,
  KickMemberRequest,
  RemoveMembersFromCallRequest,
  SetCallParticipantsRolesRequest,
  SetCallPermissionsForAllRequest,
  SetCallPermissionsForMemberRequest,
  StartCallRecordingRequest,
  StopCallRecordingRequest,
  UpdatePermissionRequestForAllRequest,
  UpdatePermissionRequestForMemberRequest,
  UpdateWaitingRoomForAllRequest,
  UpdateWaitingRoomForMemberRequest,
  WaitingRoomAccessRequest,
} from './call/call_requests_pb';
import { file_call_call_requests } from './call/call_requests_pb';
import type {
  AddMembersToCallResponse,
  CallPongResponse,
  ClearPermissionsForMemberResponse,
  CreatePermissionRequestResponse,
  DeclineCallResponse,
  FinishForAllResponse,
  ForceMuteResponse,
  GetCallLinkResponse,
  GetCallMembersByCameraOrScreenIdsResponse,
  GetCallMembersByIdsResponse,
  GetCallMembersResponse,
  GetCallPermissionsResponse,
  GetPermissionRequestsResponse,
  JoinToCallResponse,
  KickMemberResponse,
  RemoveMembersFromCallResponse,
  SetCallParticipantsRolesResponse,
  SetCallPermissionsForAllResponse,
  SetCallPermissionsForMemberResponse,
  StartCallRecordingResponse,
  StopCallRecordingResponse,
  UpdatePermissionRequestForAllResponse,
  UpdatePermissionRequestForMemberResponse,
  UpdateWaitingRoomForAllResponse,
  UpdateWaitingRoomForMemberResponse,
  WaitingRoomAccessResponse,
} from './call/call_responses_pb';
import { file_call_call_responses } from './call/call_responses_pb';
import { file_common_common_responses } from './common/common_responses_pb';
import type { CommonErrorResponse } from './error/error_responses_pb';
import { file_error_error_responses } from './error/error_responses_pb';

/**
 * Describes the file call_websocket.proto.
 */
export const file_call_websocket: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_error_error_responses,
      file_call_call_requests,
      file_call_call_responses,
      file_call_call_model,
      file_call_call_realtime_events,
      file_common_common_responses,
    ]
  );

/**
 * client -> server
 * /calls/{channel_id}/connect?token={access_token}
 * Example: ws://localhost:8080/calls/123/connect?token=1234567890
 *
 * @generated from message com.gem.bff.contract.CallWsRequest
 */
export type CallWsRequest = Message<'com.gem.bff.contract.CallWsRequest'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CallWsRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallRequest request = 1;
         */
        value: CallRequest;
        case: 'request';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CallWsRequest.
 * Use `create(CallWsRequestSchema)` to create a new message.
 */
export const CallWsRequestSchema: GenMessage<CallWsRequest> =
  /*@__PURE__*/
  messageDesc(file_call_websocket, 0);

/**
 * server -> client
 *
 * @generated from message com.gem.bff.contract.CallWsResponse
 */
export type CallWsResponse = Message<'com.gem.bff.contract.CallWsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CallWsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeCallEvent event = 1;
         */
        value: RealtimeCallEvent;
        case: 'event';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallResponse response = 2;
         */
        value: CallResponse;
        case: 'response';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CallWsResponse.
 * Use `create(CallWsResponseSchema)` to create a new message.
 */
export const CallWsResponseSchema: GenMessage<CallWsResponse> =
  /*@__PURE__*/
  messageDesc(file_call_websocket, 1);

/**
 * @generated from message com.gem.bff.contract.CallRequest
 */
export type CallRequest = Message<'com.gem.bff.contract.CallRequest'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from oneof com.gem.bff.contract.CallRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.JoinToCallRequest joinToCall = 3;
         */
        value: JoinToCallRequest;
        case: 'joinToCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.FinishForAllRequest finishForAll = 4;
         */
        value: FinishForAllRequest;
        case: 'finishForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.KickMemberRequest kickMember = 5;
         */
        value: KickMemberRequest;
        case: 'kickMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ForceMuteRequest forceMute = 6;
         */
        value: ForceMuteRequest;
        case: 'forceMute';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StartCallRecordingRequest startCallRecording = 9;
         */
        value: StartCallRecordingRequest;
        case: 'startCallRecording';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StopCallRecordingRequest stopCallRecording = 10;
         */
        value: StopCallRecordingRequest;
        case: 'stopCallRecording';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallPermissionsRequest getCallPermissions = 11;
         */
        value: GetCallPermissionsRequest;
        case: 'getCallPermissions';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallPermissionsForAllRequest setCallPermissionsForAll = 12;
         */
        value: SetCallPermissionsForAllRequest;
        case: 'setCallPermissionsForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallPermissionsForMemberRequest setCallPermissionsForMember = 13;
         */
        value: SetCallPermissionsForMemberRequest;
        case: 'setCallPermissionsForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearPermissionsForMemberRequest clearPermissionsForMember = 14;
         */
        value: ClearPermissionsForMemberRequest;
        case: 'clearPermissionsForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreatePermissionRequestRequest createPermissionRequest = 15;
         */
        value: CreatePermissionRequestRequest;
        case: 'createPermissionRequest';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetPermissionRequestsRequest getPermissionRequests = 16;
         */
        value: GetPermissionRequestsRequest;
        case: 'getPermissionRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdatePermissionRequestForMemberRequest updatePermissionRequestForMember = 17;
         */
        value: UpdatePermissionRequestForMemberRequest;
        case: 'updatePermissionRequestForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdatePermissionRequestForAllRequest updatePermissionRequestForAll = 18;
         */
        value: UpdatePermissionRequestForAllRequest;
        case: 'updatePermissionRequestForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersRequest getCallMembers = 19;
         */
        value: GetCallMembersRequest;
        case: 'getCallMembers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsRequest getCallMembersByCameraOrScreenIds = 20;
         */
        value: GetCallMembersByCameraOrScreenIdsRequest;
        case: 'getCallMembersByCameraOrScreenIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddMembersToCallRequest addMembersToCall = 21;
         */
        value: AddMembersToCallRequest;
        case: 'addMembersToCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveMembersFromCallRequest removeMembersFromCall = 22;
         */
        value: RemoveMembersFromCallRequest;
        case: 'removeMembersFromCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallLinkRequest getCallLink = 24;
         */
        value: GetCallLinkRequest;
        case: 'getCallLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForMemberRequest updateWaitingRoomForMember = 25;
         */
        value: UpdateWaitingRoomForMemberRequest;
        case: 'updateWaitingRoomForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForAllRequest updateWaitingRoomForAll = 26;
         */
        value: UpdateWaitingRoomForAllRequest;
        case: 'updateWaitingRoomForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.WaitingRoomAccessRequest waitingRoomAccess = 27;
         */
        value: WaitingRoomAccessRequest;
        case: 'waitingRoomAccess';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineCallRequest declineCall = 28;
         */
        value: DeclineCallRequest;
        case: 'declineCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallPingRequest ping = 29;
         */
        value: CallPingRequest;
        case: 'ping';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallParticipantsRolesRequest setCallParticipantsRoles = 30;
         */
        value: SetCallParticipantsRolesRequest;
        case: 'setCallParticipantsRoles';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersByIdsRequest getCallMembersByIds = 31;
         */
        value: GetCallMembersByIdsRequest;
        case: 'getCallMembersByIds';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CallRequest.
 * Use `create(CallRequestSchema)` to create a new message.
 */
export const CallRequestSchema: GenMessage<CallRequest> =
  /*@__PURE__*/
  messageDesc(file_call_websocket, 2);

/**
 * @generated from message com.gem.bff.contract.CallResponse
 */
export type CallResponse = Message<'com.gem.bff.contract.CallResponse'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: string traceId = 23;
   */
  traceId: string;

  /**
   * @generated from oneof com.gem.bff.contract.CallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CommonErrorResponse error = 2;
         */
        value: CommonErrorResponse;
        case: 'error';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.JoinToCallResponse joinToCall = 3;
         */
        value: JoinToCallResponse;
        case: 'joinToCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.FinishForAllResponse finishForAll = 4;
         */
        value: FinishForAllResponse;
        case: 'finishForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.KickMemberResponse kickMember = 5;
         */
        value: KickMemberResponse;
        case: 'kickMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ForceMuteResponse forceMute = 6;
         */
        value: ForceMuteResponse;
        case: 'forceMute';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StartCallRecordingResponse startCallRecording = 9;
         */
        value: StartCallRecordingResponse;
        case: 'startCallRecording';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.StopCallRecordingResponse stopCallRecording = 10;
         */
        value: StopCallRecordingResponse;
        case: 'stopCallRecording';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallPermissionsResponse getCallPermissions = 11;
         */
        value: GetCallPermissionsResponse;
        case: 'getCallPermissions';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallPermissionsForAllResponse setCallPermissionsForAll = 12;
         */
        value: SetCallPermissionsForAllResponse;
        case: 'setCallPermissionsForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallPermissionsForMemberResponse setCallPermissionsForMember = 13;
         */
        value: SetCallPermissionsForMemberResponse;
        case: 'setCallPermissionsForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearPermissionsForMemberResponse clearPermissionsForMember = 14;
         */
        value: ClearPermissionsForMemberResponse;
        case: 'clearPermissionsForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreatePermissionRequestResponse createPermissionRequest = 15;
         */
        value: CreatePermissionRequestResponse;
        case: 'createPermissionRequest';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetPermissionRequestsResponse getPermissionRequests = 16;
         */
        value: GetPermissionRequestsResponse;
        case: 'getPermissionRequests';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdatePermissionRequestForMemberResponse updatePermissionRequestForMember = 17;
         */
        value: UpdatePermissionRequestForMemberResponse;
        case: 'updatePermissionRequestForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdatePermissionRequestForAllResponse updatePermissionRequestForAll = 18;
         */
        value: UpdatePermissionRequestForAllResponse;
        case: 'updatePermissionRequestForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersResponse getCallMembers = 19;
         */
        value: GetCallMembersResponse;
        case: 'getCallMembers';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersByCameraOrScreenIdsResponse getCallMembersByCameraOrScreenIds = 20;
         */
        value: GetCallMembersByCameraOrScreenIdsResponse;
        case: 'getCallMembersByCameraOrScreenIds';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.AddMembersToCallResponse addMembersToCall = 21;
         */
        value: AddMembersToCallResponse;
        case: 'addMembersToCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.RemoveMembersFromCallResponse removeMembersFromCall = 22;
         */
        value: RemoveMembersFromCallResponse;
        case: 'removeMembersFromCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallLinkResponse getCallLink = 24;
         */
        value: GetCallLinkResponse;
        case: 'getCallLink';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForMemberResponse updateWaitingRoomForMember = 25;
         */
        value: UpdateWaitingRoomForMemberResponse;
        case: 'updateWaitingRoomForMember';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateWaitingRoomForAllResponse updateWaitingRoomForAll = 26;
         */
        value: UpdateWaitingRoomForAllResponse;
        case: 'updateWaitingRoomForAll';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.WaitingRoomAccessResponse waitingRoomAccess = 27;
         */
        value: WaitingRoomAccessResponse;
        case: 'waitingRoomAccess';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeclineCallResponse declineCall = 28;
         */
        value: DeclineCallResponse;
        case: 'declineCall';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CallPongResponse pongResponse = 29;
         */
        value: CallPongResponse;
        case: 'pongResponse';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SetCallParticipantsRolesResponse setCallParticipantsRoles = 30;
         */
        value: SetCallParticipantsRolesResponse;
        case: 'setCallParticipantsRoles';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCallMembersByIdsResponse getCallMembersByIds = 31;
         */
        value: GetCallMembersByIdsResponse;
        case: 'getCallMembersByIds';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CallResponse.
 * Use `create(CallResponseSchema)` to create a new message.
 */
export const CallResponseSchema: GenMessage<CallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_websocket, 3);
